import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Label, FormGroup, Col } from 'reactstrap';
import { SiteTitle } from "./SiteTitle";
import { api_url } from "./globalFunction/global_string";
import { formatDate } from "./globalFunction/response_action";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectName } from "./BasicComponents/SelectName";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";
import { ReactSelectUnitproxyApply } from "./BasicComponents/reactSelectUnitproxyApply";

import Swal from 'sweetalert2';


export class SiteScanHistoryData extends Component {
  static displayName = SiteScanHistoryData.name;

  constructor(props) {
    super(props);
    this.state = {
      scanDetailsModal: false,
      currentHistoryData: null,
      selectedHistoryItem: null,
      average_scan_usage: '',
      average_number_pages: '',
      average_number_requests: '',
      activeTab: '3',
      showPasswordModal: false, //打開寄送密碼的modal
    };
    // 綁定函數到類的實例上
    this.handleShowPasswordModal = this.handleShowPasswordModal.bind(this);
    this.handleClosePasswordModal = this.handleClosePasswordModal.bind(this);
  }

  //做分頁顯示
  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  handleClose = () => {
    this.setState({ scanDetailsModal: false });
  }

  handleShow = () => {
    this.setState({ scanDetailsModal: true });
  }

  //打開寄送密碼model
  handleShowPasswordModal = (rowGuid, scanname, net_name, unit_name) => {
    this.setState({ showPasswordModal: true, currentGuid: rowGuid, scanname: scanname, net_name: net_name, unit_name: unit_name });
  };
  //關掉寄送密碼model
  handleClosePasswordModal = () => {
    this.setState({ showPasswordModal: false }, () => {
      console.log("Modal closed, new state:", this.state.showPasswordModal);
    });
  };

  DownLoadPaper = async (scan_id) => {
    this.setState({ fileLoading: true });
    // const scan_id = event.target.value;
    const apiUrl = api_url + "/api/SCHE/CheckAndDownloadReportAsync";
    const formData = new FormData();
    formData.append("scan_id", scan_id);

    await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Authorization": localStorage.getItem('accessToken')
      },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        const row = (arr_status[1] !== null || arr_status[1] !== '') ? arr_status[1] : '';

        const regex = /(C:\/AppScan_API\/|AppScan_API\/)/;
        const convertedString = row.replace(regex, "");


        fetch(api_url + "/" + convertedString)
          .then(response => response.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const finalFileName = convertedString.replace('Upload/', '');
            a.download = finalFileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch(error => console.error('Error downloading ZIP file:', error))
          .finally(() => {
            this.setState({ fileLoading: false });
          })
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }
  //掃描資訊
  ScanInfo = (scan_id) => {
    const storedHistoryData = sessionStorage.getItem('CurrentHistoryData');
    if (storedHistoryData) {
      let parsedHistoryData = JSON.parse(storedHistoryData);
      const matchingHistoryItem = parsedHistoryData.find(item => item.scan_id === scan_id);
      console.log(matchingHistoryItem)

      //計算每秒傳送request數量
      const durationParts = matchingHistoryItem.scan_duration.split(':');
      const hoursInSeconds = parseInt(durationParts[0]) * 3600;
      const minutesInSeconds = parseInt(durationParts[1]) * 60;
      const seconds = parseInt(durationParts[2]);
      const totalSeconds = hoursInSeconds + minutesInSeconds + seconds;
      const requestsPerSecond = matchingHistoryItem.request_count / totalSeconds;
      const roundedRequestsPerSecond = parseFloat(requestsPerSecond.toFixed(2));

      matchingHistoryItem.requestsPerSecond = roundedRequestsPerSecond;

      if (matchingHistoryItem) {
        console.log(matchingHistoryItem)
        this.setState({
          selectedHistoryItem: matchingHistoryItem,
          scanDetailsModal: true
        });
      } else {
        console.log('沒有找到匹配的歷史資料項目');
      }
    } else {
      console.log('sessionStorage中沒有歷史資料');
    }
  }



  componentDidMount() {
    const storedHistoryData = sessionStorage.getItem('CurrentHistoryData');
    if (storedHistoryData) {
      let parsedHistoryData = JSON.parse(storedHistoryData);

      const averages = {
        '1': { scan_usage: 0, number_pages: 0, number_requests: 0, count: 0 },
        '2': { scan_usage: 0, number_pages: 0, number_requests: 0, count: 0 },
        '3': { scan_usage: 0, number_pages: 0, number_requests: 0, count: 0 }
      };

      // 遍歷每個項目，並將值加到對應的betaversion分組
      parsedHistoryData.forEach(item => {
        const version = item.betaversion;

        if (averages[version]) {
          let duration = this.convertDurationToSeconds(item.scan_duration);
          let pagesCount = parseInt(item.scanned_page_count, 10);
          let requestsCount = parseInt(item.request_count, 10);

          // 確保duration, pagesCount, requestsCount不是NaN
          duration = !isNaN(duration) ? duration : 0;
          pagesCount = !isNaN(pagesCount) ? pagesCount : 0;
          requestsCount = !isNaN(requestsCount) ? requestsCount : 0;

          averages[version].scan_usage += duration;
          averages[version].number_pages += pagesCount;
          averages[version].number_requests += requestsCount;
          averages[version].count++;
        }
      });
      parsedHistoryData.sort((a, b) => a.historyNumber - b.historyNumber);
      // 初始化betaversion分組的平均值對象
      // 計算每個分組的平均值
      Object.keys(averages).forEach(version => {
        if (averages[version].count > 0) {
          let averageScanUsage = (averages[version].scan_usage / averages[version].count).toFixed(2);
          averages[version].scan_usage = this.convertSecondsToDuration(parseFloat(averageScanUsage));
          averages[version].number_pages = parseFloat(averages[version].number_pages / averages[version].count).toFixed(2);
          averages[version].number_requests = parseFloat((averages[version].number_requests / averages[version].count).toFixed(2));
        }
      });


      // 更新狀態以包含平均值和原始數據
      this.setState({
        currentHistoryData: parsedHistoryData,
        averages // 包含了每個betaversion的平均值
      });
    }
  }


  convertDurationToSeconds(duration) {
    if (typeof duration === 'string' && duration.includes(':')) {
      const [hours, minutes, seconds] = duration.split(':').map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    }
    // Handle the case where duration is not a string or is an invalid format
    return 0;
  }

  // 將秒數轉換回 HH:MM:SS 格式
  convertSecondsToDuration(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = Math.floor(seconds % 60);
    const decimalPart = (seconds % 1).toFixed(2).substring(1); // 獲取小數部分

    return [hours, minutes, sec]
      .map(v => v < 10 ? '0' + v : v) // 確保雙位數格式
      .join(':') + decimalPart; // 添加小數部分
  }


  // handleTrackUnitOrNet = async (scan_id, trackType) => {
  //   const apiUrl = api_url + "/api/SCHE/ToggleTrackNetOrUnit";
  //   const formData = new FormData();
  //   formData.append("scan_id", scan_id);
  //   formData.append("user_type", localStorage.getItem('login_user_type'));
  //   formData.append("trackType", trackType);
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       headers: {
  //         "Authorization": localStorage.getItem('accessToken')
  //       },
  //       body: formData
  //     });

  //     if (response.ok) {
  //       const result = await response.json();
  //       console.log(result);
  //       if (result.statusCode === 200) {
  //         Swal.fire('成功', `${result.row}`, 'success');
  //         const storedHistoryData = sessionStorage.getItem('CurrentHistoryData');
  //         if (storedHistoryData) {
  //           let parsedHistoryData = JSON.parse(storedHistoryData);
  //           // 找到需要更新的項目
  //           const historyIndex = parsedHistoryData.findIndex(item => item.scan_id === scan_id);

  //           if (historyIndex !== -1) {
  //             // 做出更新（例如切換追蹤狀態）
  //             if (trackType === "unit") {
  //               // 如果區網追蹤為true，則不允許更改單位追蹤狀態
  //               if (!parsedHistoryData[historyIndex].isNetTracked) {
  //                 parsedHistoryData[historyIndex].isUnitTracked = !parsedHistoryData[historyIndex].isUnitTracked;
  //               } else {
  //                 // 如果已經是區網追蹤，則顯示錯誤信息
  //                 Swal.fire('錯誤', '區網追蹤已啟用，無法更改單位追蹤狀態。', 'error');
  //               }
  //             } else {
  //               // 更新區網追蹤的狀態
  //               parsedHistoryData[historyIndex].isNetTracked = !parsedHistoryData[historyIndex].isNetTracked;
  //               // 如果啟用區網追蹤，則自動設置單位追蹤為true
  //               if (parsedHistoryData[historyIndex].isNetTracked) {
  //                 parsedHistoryData[historyIndex].isUnitTracked = true;
  //               }
  //             }


  //             parsedHistoryData.sort((a, b) => a.historyNumber - b.historyNumber);
  //             // 保存更新後的數據回 sessionStorage
  //             sessionStorage.setItem('CurrentHistoryData', JSON.stringify(parsedHistoryData));
  //             // 更新組件的狀態來反映改變
  //             this.setState({ currentHistoryData: parsedHistoryData });
  //           }
  //         }
  //         console.log("Updated session storage data:", JSON.parse(sessionStorage.getItem('CurrentHistoryData')));

  //       } else {
  //         // 處理非 isSuccess 結果
  //         Swal.fire('錯誤', `${result.row}` || '操作失敗', 'error');
  //       }
  //     } else {
  //       // 處理 response.ok 為 false 的情況
  //       Swal.fire('錯誤', '網路回應有誤', 'error');
  //     }
  //   } catch (error) {
  //     console.error('Error during track unit:', error);
  //     Swal.fire('錯誤', '追蹤單位過程中發生錯誤', 'error');
  //   }
  // };

  renderPasswordModal = () => {
    const userType = localStorage.getItem('login_user_type');
    const selectnetid = localStorage.getItem('login_user_net_id');
    const net_name = localStorage.getItem('login_user_net_name');
    let formContent;
    if (userType === 'S') {
      formContent = (
        <>
          <FormGroup row inline>
            <Label for="local_net_id" sm={2}>區網名稱</Label>
            <Col sm={10}>
              <SelectNet
                parentName={'superS'}
                id={'excel_net_name'}
                name={'excel_net_name'}
                requiredAPI={'/api/JRCC/GetLocalNetId'}
                handleNetSelectChange={this.handleNetSelectChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <ReactSelectUnitproxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="local_user_id" sm={2}>人員資料</Label>
            <Col sm={10}>
              <SelectName
                parentName={'superS'}
                id={'excel_user_name'}
                name={'excel_user_name'}
                requiredAPI={'/api/Async/GetUserdatalist'}
                handleUserSelectChange={this.handleUserSelectChange}
                selectedUnitproxy={this.state.selectedUnitproxy}
                local_unit_proxy_name={this.state.local_unit_proxy_name}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
        </>
      );
    } else if (userType === 'M') {
      formContent = (
        <>
          <FormGroup row inline>
            <Label sm={2}>區網名稱</Label>
            <Col sm={10}>
              <span className="form-control-plaintext">{net_name}</span>
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <ReactSelectUnitproxyApply
                parentName={'superM'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={selectnetid}
                local_net_name={net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="local_user_id" sm={2}>人員資料</Label>
            <Col sm={10}>
              <SelectName
                parentName={'superM'}
                id={'excel_user_name'}
                name={'excel_user_name'}
                requiredAPI={'/api/Async/GetUserdatalist'}
                handleUserSelectChange={this.handleUserSelectChange}
                selectedUnitproxy={this.state.selectedUnitproxy}
                local_unit_proxy_name={this.state.local_unit_proxy_name}
                selectnet={selectnetid}
                local_net_name={net_name}
              />
            </Col>
          </FormGroup>
        </>
      );
    } else {
      formContent = (
        <FormGroup row inline>
          <Label for="local_user_id" sm={2}>人員資料</Label>
          <Col sm={10}>
            <SelectName
              parentName={'superN'}
              id={'excel_user_name'}
              name={'excel_user_name'}
              requiredAPI={'/api/Async/GetUserdatalist'}
              handleUserSelectChange={this.handleUserSelectChange}
            />
          </Col>
        </FormGroup>
      );
    }

    return (
      <Modal isOpen={this.state.showPasswordModal} toggle={this.handleClosePasswordModal} size="lg">
        <ModalHeader toggle={this.handleClosePasswordModal}>寄送密碼</ModalHeader>


        <ModalBody>
          <ModalBody>
            {formContent}
          </ModalBody>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={this.handleClosePasswordModal}>
            取消
          </Button>
          {' '}
          <Button color="primary" onClick={this.handleSendReportPaswword}>
            確認
          </Button>
        </ModalFooter>
      </Modal>
    );
  };
  //寄送報告密碼
  handleSendReportPaswword = async () => {
    let apiUrl = api_url + "/api/async/SendReportPaswword";
    const formData = new FormData();
    const { selectnet, selectedUnitproxy, selecteduser, currentGuid, scanname, net_name, unit_name, userType } = this.state;
    if (userType === "S") {
      if (!selectnet || !selectedUnitproxy || !selecteduser) {
        Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
        return; // 提前終止函數
      }
    } else if (userType === "M") {
      if (!selectedUnitproxy || !selecteduser) {
        Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
        return; // 提前終止函數
      }
    } else if (userType === "N") {
      if (!selecteduser) {
        Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
        return; // 提前終止函數
      }
    }

    formData.append("send_user_id", localStorage.getItem('login_user_id'));
    formData.append("local_net_id", selectnet);
    formData.append("local_unit_id", selectedUnitproxy);
    formData.append("user_id", selecteduser)
    formData.append("currentGuid", currentGuid);
    formData.append("scanname", scanname);
    formData.append("net_name", net_name);
    formData.append("unit_name", unit_name);
    formData.append("type", "HCL");

    await fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data)
        if (data.statusCode === 200) {
          Swal.fire("成功", "發送成功", "success").then(() => {
            this.handleClosePasswordModal();
          });
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectnet: value, local_net_name: selectedName }, () => {
      console.log("Selected net updated:", this.state.selectnet, this.state.local_net_name);
    });
  };
  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName }, () => {
      console.log("Selected unit updated:", this.state.selectedUnitproxy, this.state.local_unit_proxy_name);
    });
  };
  // 處理人員選擇
  handleUserSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState({ selecteduser: value, local_user_name: selectedName }, () => {
      console.log("Selected net updated:", this.state.selecteduser, this.state.local_user_name);
    });
  };
  render() {
    const { currentHistoryData, selectedHistoryItem, scanDetailsModal, average_scan_usage, average_number_pages, average_number_requests, activeTab, averages } = this.state;
    const currentAverages = averages && averages[activeTab];

    // 分類數據根據betaversion
    const testData = currentHistoryData ? currentHistoryData.filter(data => data.betaversion === '1') : [];
    const devData = currentHistoryData ? currentHistoryData.filter(data => data.betaversion === '2') : [];
    const prodData = currentHistoryData ? currentHistoryData.filter(data => data.betaversion === '3') : [];

    const RiskHeader = ({ title, color }) => {
      return (
        <div style={{
          display: 'inline-block',
          backgroundColor: color,
          padding: '10px',
          borderRadius: '0px', // 移除圓角以使框框碰在一起
          color: 'white',
          margin: '0px' // 移除邊距以使框框碰在一起
        }}>
          {title}
        </div>
      );
    };
    const StatusIndicator = ({ isTrackedreport, betaversion }) => {
      let color;
      const numericIsTrackedreport = +isTrackedreport;
      if (betaversion === "1" || betaversion === "2") {
        color = 'grey';
      } else if (betaversion === "3") {
        switch (numericIsTrackedreport) {
          case 2:
            color = 'green';
            break;
          case 1:
            color = 'red';
            break;
          default:
            color = 'grey';
            break;
        }
      }

      return (
        <div style={{
          width: '15px',
          height: '15px',
          borderRadius: '50%',
          backgroundColor: color,
          display: 'inline-block',
        }} />
      );
    };
    const columns = [
      {
        name: '追蹤狀態',
        cell: row => (
          <StatusIndicator
            isTrackedreport={row.isTrackedreport}
            betaversion={row.betaversion}
          />
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },

      {
        name: '流水號',
        cell: row => {
          // 確保原始格式存在且是字符串
          const originalFormat = row.build_date;
          if (typeof originalFormat === 'string') {
            const newFormat = originalFormat
              .replace(/\//g, "")
              .replace(/:/g, "")
              .replace(/ /g, "");
            return (
              <div className="Research-wrap">
                {`${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`}
              </div>
            );
          }
          // 如果原始格式不存在，返回一個默認或空字符串
          return <div className="Research-wrap">格式錯誤</div>;
        },
        sortable: true,
      },
      {
        name: '單位',
        selector: row => row.local_unit_name,
        cell: row => <div className="Research-wrap">{row.local_unit_name}</div>,
        sortable: true,
      },
      {
        name: '網站名稱',
        cell: row => {
          const BuildingDateText = formatDate(row.build_date);
          let opcallityText;
          if (row.opcallity === '1') {
            opcallityText = '普';
          } else if (row.opcallity === '2') {
            opcallityText = '中';
          } else if (row.opcallity === '3') {
            opcallityText = '高';
          } else {
            opcallityText = '其他';
          }

          return (
            <div>
              <a href={row.url_addr}>{row.url_name}</a>
              <br />
              {BuildingDateText}
              <br />
              {opcallityText}
            </div>
          );
        },
      },
      {
        name: '狀態',
        selector: row => row.scan_status,
        cell: row => {
          if (row.scan_status === '2') return '掃描成功';
          if (row.scan_status === '1') return '掃描中';
          if (row.scan_status === '3') return `掃描失敗 ${row.note}`;
          if (row.scan_status === '0') return '排程中';
          return '未知';
        },
        sortable: true,
      },
      {
        name: <RiskHeader title="重風險" color="purple" />,
        selector: row => row.heavy,
      },
      {
        name: <RiskHeader title="高風險" color="red" />,
        selector: row => row.high,
      },
      {
        name: <RiskHeader title="中風險" color="orange" />,
        selector: row => row.meddle,
      },
      {
        name: <RiskHeader title="低風險" color="blue" />,
        selector: row => row.low,
      },
      {
        name: <RiskHeader title="訊息" color="green" />,
        selector: row => row.message,
      },
      {
        name: '操作',
        cell: row => {
          const userType = localStorage.getItem('login_user_type');
          const rowGuid = row.id;
          const originalFormat = row.build_date;
          const newFormat = originalFormat.replace(/[/: ]/g, "");
          const scanname = `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
          const net_name = row.local_net_name;
          const unit_name = row.local_unit_name;
          console.log(row)
          return (
            <div>
              {row.scan_status === "2" && (
                <>
                  {row.downland_url && (
                    <>
                      <Button type="button" className='btn btn-primary mx-1' onClick={() => this.DownLoadPaper(row.scan_id)}>下載報告</Button>

                      <Button
                        type="button"
                        className="btn btn-secondary mx-1"
                        onClick={() => this.handleShowPasswordModal(rowGuid, scanname, net_name, unit_name)}
                      >
                        寄送密碼
                      </Button>
                    </>
                  )}

                  <Button type="button" className='btn btn-secondary mx-1' onClick={() => this.ScanInfo(row.scan_id)}>掃描資訊</Button>
                </>
              )}


            </div>
          );
        },
        sortable: false,
      },

    ];
    const userType = localStorage.getItem('login_user_type');
    if (userType === 'S') {
      columns.splice(1, 0, {
        name: '區網',
        selector: row => row.local_net_name,
        cell: row => <div className="Research-wrap">{row.local_net_name}</div>,
        sortable: true,
      });
    }
    return (
      <div>
        <SiteTitle />
        <div>
          <h1 id="tableLabel" className='mb-3' style={{ marginTop: '5rem' }}>歷史數據</h1>
          {/* Tab標籤 */}
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => { this.toggleTab('1'); }}
                style={{ fontSize: '1.25rem' }} // 增加字體大小
              >
                測試版
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => { this.toggleTab('2'); }}
                style={{ fontSize: '1.25rem' }} // 增加字體大小
              >
                開發版
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '3' })}
                onClick={() => { this.toggleTab('3'); }}
                style={{ fontSize: '1.25rem' }} // 增加字體大小
              >
                上線版
              </NavLink>
            </NavItem>
          </Nav>


          {currentAverages && (
            <div>
              <Row>
                <Col className="riskSummaryBox"><strong>平均掃描使用時間: {currentAverages.scan_usage}</strong></Col>
                <Col className="riskSummaryBox"><strong>平均掃描頁面數量: {currentAverages.number_pages}</strong></Col>
                <Col className="riskSummaryBox"><strong>平均傳送request數量: {currentAverages.number_requests}</strong></Col>
              </Row>
            </div>
          )}

          {/* Tab內容 */}
          <TabContent activeTab={activeTab}>

            {/* 測試版數據 */}
            <TabPane tabId="1">
              <div
                style={{
                  position: "relative",
                  width: "120%",        // 讓 DataTable 可以完整顯示
                  borderRadius: "inherit",
                  overflowX: "hidden",  // 隱藏超出的內容
                  overflowY: "hidden",
                  minHeight: "0",
                  right: "100px",       // 讓表格右移
                }}
              >
                <DataTable
                  columns={columns}
                  data={testData} // testData定義
                  pagination  // 啟用分頁
                  paginationPerPage={20}  // 每頁顯示 20 筆資料
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, testData.length]}  // 可選的「每頁顯示資料數量」
                />
              </div>
            </TabPane>

            {/* 開發版數據 */}
            <TabPane tabId="2">
              <div
                style={{
                  position: "relative",
                  width: "120%",        // 讓 DataTable 可以完整顯示
                  borderRadius: "inherit",
                  overflowX: "hidden",  // 隱藏超出的內容
                  overflowY: "hidden",
                  minHeight: "0",
                  right: "100px",       // 讓表格右移
                }}
              >
                <DataTable
                  columns={columns}
                  data={devData} // devData定義
                  pagination  // 啟用分頁
                  paginationPerPage={20}  // 每頁顯示 20 筆資料
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, devData.length]}  // 可選的「每頁顯示資料數量」
                />
              </div>
            </TabPane>

            {/* 上線版數據 */}
            <TabPane tabId="3">
              <div
                style={{
                  position: "relative",
                  width: "120%",        // 讓 DataTable 可以完整顯示
                  borderRadius: "inherit",
                  overflowX: "hidden",  // 隱藏超出的內容
                  overflowY: "hidden",
                  minHeight: "0",
                  right: "100px",       // 讓表格右移
                }}
              >
                <DataTable
                  columns={columns}
                  data={prodData} // prodData定義
                  pagination  // 啟用分頁
                  paginationPerPage={20}  // 每頁顯示 20 筆資料
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, prodData.length]}  // 可選的「每頁顯示資料數量」
                />
              </div>
            </TabPane>

          </TabContent>

          < Row justify='center' >
            <Col lg="12" md="12">
              <div style={{ backgroundColor: 'lightblue', color: 'black', padding: '10px', marginTop: '20px' }}>
                <h4>注意事項</h4>
                <p>掃描失敗的錯誤訊息:</p>
                <ol>
                  <li>
                    <strong>掃描失敗 已暫停 (錯誤不明：SDK Server Down Error)</strong>
                    <p>原因：執行弱掃的掃描過程中導致網頁伺服器掛掉。</p>
                    <p>解決方式：請確認網頁伺服器已經可以正確運行後，再次執行掃描。如果仍出現該問題，請聯繫系統維護人員。</p>
                  </li>
                  <li>
                    <strong>掃描失敗 已暫停 (記憶體不足錯誤。)</strong>
                    <p>原因：此為弱掃平台掃描主機出現錯誤。</p>
                    <p>解決方式：請聯繫系統維護人員。</p>
                  </li>
                  <li>
                    <strong>掃描失敗 已暫停 (錯誤不明：SDK Error. Scan failed to start. Either starting URL is not accessible or other network issues.)</strong>
                    <p>原因：這是因為掃描主機無法與被掃瞄的主機相連。</p>
                    <p>解決方式：</p>
                    <ul>
                      <li>被掃描主機網址是錯誤的，請確認主機網址可以被連線。</li>
                      <li>被掃描主機未開機。</li>
                      <li>未將140.113.27.234在防火牆上設定白名單。</li>
                    </ul>
                  </li>
                  <div style={{ margin: "1em 0" }}></div>
                  <li>
                    <strong>掃描失敗 已暫停 (錯誤不明：無效的 URI: 無法決定 URI 的格式。)</strong>
                    <p>原因：輸入的資訊不是一個網址。</p>
                    <p>解決方式：請確認輸入為http://xxx.xxx/ 或 https://xxx.xxx/。</p>
                  </li>
                </ol>

              </div>
            </Col>
          </Row >

          {this.renderPasswordModal()}
          < Modal isOpen={scanDetailsModal} toggle={this.handleClose} >
            <ModalHeader toggle={this.handleClose} className="modal-header">
              掃描資訊
            </ModalHeader>
            <ModalBody>
              {selectedHistoryItem && (
                <>
                  <p><strong>申請掃描時間：</strong>{selectedHistoryItem.scan_request_time}</p>
                  <p><strong>開始掃描時間：</strong>{selectedHistoryItem.scan_start_time}</p>
                  <p><strong>結束掃描時間：</strong>{selectedHistoryItem.scan_end_time}</p>
                  <p><strong>掃描使用時間：</strong>{selectedHistoryItem.scan_duration}</p>
                  <p><strong>掃描頁面數量：</strong>{selectedHistoryItem.scanned_page_count}</p>
                  <p><strong>傳送request總數：</strong>{selectedHistoryItem.request_count}</p>
                  <p><strong>每秒傳送request數量：</strong>{selectedHistoryItem.requestsPerSecond}</p>
                </>
              )}
            </ModalBody>
            <ModalFooter className="modal-footer">
              <Button color="secondary" onClick={this.handleClose}>關閉</Button>
            </ModalFooter>
          </Modal >
        </div >
      </div >
    );
  }

}

